import styled from "styled-components"
import { rem } from "@mantine/core"

export const TooltipContainer = styled.div`
    background-color: black;
    color: white;

    font-size: ${rem(12)};
    line-height: 1.5;
    padding: ${rem(10)};

    border-radius: ${rem(4)};
`

export const IconWrapper = styled.div`
    &:hover {
        filter: brightness(0.5);
    }
`
